import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import dayjs from 'dayjs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginStore } from './stores/login.store';

@Component({
  selector: 'app-login',
  imports: [FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  loading = signal(false);
  currentYear = dayjs().year();

  loginStore = inject(LoginStore);
  router = inject(Router);
  fb = inject(FormBuilder);
  destroyRef = inject(DestroyRef);

  private loginSuccess$ = toObservable(this.loginStore.loginSuccess);
  private loginError$ = toObservable(this.loginStore.error);

  ngOnInit(): void {
    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
    });

    this.loginSuccess$
      .pipe(takeUntilDestroyed(this.destroyRef), filter(f => f))
      .subscribe(() => {
        this.loading.set(false);
        this.router.navigateByUrl('/dashboard');
      });

    this.loginError$
      .pipe(takeUntilDestroyed(this.destroyRef), filter(f => !!f))
      .subscribe(() => this.loading.set(false));
  }

  onLogin() {
    if (this.loading()) return;
    this.loading.set(true);
    this.loginStore.login(this.form.value);
  }
}
